<div mat-dialog-title class="modal-title">
  <mat-icon>fact_check</mat-icon>
  <span>Calificaciones del examen: {{ examName }}</span>
  <mat-icon class="close-button" (click)="closeModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  @if (isLoadingGrades) {
    <div class="loading-page">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  } @else {
    <div class="note">
      <button mat-stroked-button color="primary" (click)="downloadStudentsAnswers()" [disabled]="isDownloadingAnswers">
        @if (!isDownloadingAnswers) {
          <span>Descargar respuestas de todos</span>
        } @else {
          <mat-spinner class="primary-spinner"> </mat-spinner>
        }
      </button>
      <span>Total de preguntas: {{ totalQuestions }}</span>
      <span>Preguntas obligatorias: {{ requiredQuestions }}</span>
    </div>
  }

  @if (!isLoadingGrades && students.length) {
    <div class="form-control">
      <mat-form-field appearance="outline" color="primary">
        <mat-label>Buscar un estudiante</mat-label>
        @if (isSearchingStudent) {
          <mat-spinner matSuffix> </mat-spinner>
        }
        <input matInput name="studentToSearch" placeholder="Nombre o apellidos" autocomplete="off" (keyup)="filterStudent($event)" />
      </mat-form-field>
    </div>
  }

  @if (!isLoadingGrades && !filteredStudents.length) {
    <div class="no-current">No hay estudiantes disponibles</div>
  }

  <div
    class="students"
    infiniteScroll
    [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScrollDown()"
    [scrollWindow]="false"
    [infiniteScrollDisabled]="infiniteScrollDisabled"
  >
    @if (!isLoadingGrades && filteredStudents.length) {
      <div class="students-list">
        @for (student of filteredStudents; track student) {
          <div class="student">
            <div class="student-header">
              <span>{{ student.fullname }}</span>
              <button mat-stroked-button color="light" (click)="openViewExamAnswersModal(student)"> Ver respuestas </button>
            </div>
            <div class="student-content">
              <div class="answers">
                @for (answer of student.answers; track answer) {
                  <div class="answer">
                    <span>{{ answer.date | date: 'dd MMM yyyy' : '' : 'es' }}</span>
                    <div class="badge">
                      @if (answer.approved) {
                        <span class="approved">Aprobado {{ answer.grade }}</span>
                      } @else {
                        <span class="failed">Reprobado {{ answer.grade }}</span>
                      }
                      <span class="detail">Respuestas correctas: {{ answer.correctAnswers }}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</mat-dialog-content>
